import Vue from 'vue'
import App from './App.vue'
import './components/work/until/ElementUiUntil'
import i18n from './components/work/language/language'
import './components/work/until/main.css'
//  import router from './router'
import router from './components/mainConfig/routerConfig'
import * as MainMethods from './components/work/until/MainMethods'
// import './components/mainConfig/getUser'
Vue.prototype.$formateDate = MainMethods

import isMobile from './components/mainConfig/localUser'

Vue.prototype.$isMobile = isMobile
// import echarts from './components/work/until/Echarts'
// import * as echarts from 'echarts';
// Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
import axios from './components/mainConfig/axiosConfig'
// import axios from 'axios' 
Vue.prototype.axios = axios
import slideVerify from "vue-monoplasty-slide-verify";
Vue.use(slideVerify);

//生产
axios.defaults.baseURL = 'http://saw.wxu.edu.cn/thu_api'
Vue.prototype.$imagepath = 'http://saw.wxu.edu.cn/thu_file/'
Vue.prototype.$DWSurveyHtmlUrl = 'http://saw.wxu.edu.cn:8086'
Vue.prototype.$DWSurveyJarUrl = 'http://saw.wxu.edu.cn/survey_api'



//本地
// axios.defaults.baseURL = 'thu_api'
// Vue.prototype.$imagepath = 'http://localhost:8084/'
// Vue.prototype.$DWSurveyHtmlUrl = 'http://localhost:8081'
// Vue.prototype.$DWSurveyJarUrl = 'http://localhost:8111'




// Vue.prototype.$DWSurveyHtmlUrl='http://129.211.24.35:83'
// Vue.prototype.$DWSurveyJarUrl='http://129.211.24.35:8111'


//thu
// axios.defaults.baseURL='http://101.34.92.77:8089'
// Vue.prototype.$imagepath='http://101.34.92.77:81/thu'

//thu.ebookware.cn
// axios.defaults.baseURL='http://thu.ebookware.cn:8181'
// Vue.prototype.$imagepath='http://thu.ebookware.cn/thu/'

// axios.defaults.baseURL='http://101.34.92.77:8085'
// Vue.prototype.$imagepath='http://101.34.92.77:8081/'

//  Vue.prototype.$imagepath='http://www.ebookware.cn/apk/'
//  axios.defaults.baseURL='http://www.ebookware.cn:8081'

//taihu Univ
//http://www.wxu.edu.cn/r/cms/thxy/thxy2/images/logo.jpg
//color:#386afa
//JNU
//https://www.jiangnan.edu.cn/images/logo.png
//color  #006179 /





// 防止localstorage修改
window.addEventListener('storage', function () {
  sessionStorage.clear();
  router.push({ path: 'login' })
});





let thisVue = new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>'

})
export default thisVue


// WEBPACK FOOTER //
// ./src/main.js